import { DiToken, registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const GTM_ID: DiToken<string | undefined> = new DiToken<string | undefined>('gtmId', {
  factory: () => undefined
});

export function registerGtmId(gtmId: string | undefined): void {
  registerDiToken(GTM_ID, () => gtmId);
}
